import { render, staticRenderFns } from "./Pill.vue?vue&type=template&id=5a54cb50&scoped=true&"
import script from "./Pill.vue?vue&type=script&lang=js&"
export * from "./Pill.vue?vue&type=script&lang=js&"
import style0 from "./Pill.vue?vue&type=style&index=0&id=5a54cb50&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a54cb50",
  null
  
)

export default component.exports